/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

/*eslint no-useless-escape:0*/

module.exports = function ( app ) {
    var ts       = require('../ts')(app),
        gettext  = require('mag-gettext').gettext;

    return {
        id: 'timeShiftDelay',
        name: gettext('Delay'),
        description: gettext('Delay before the TimeShift starts recording.'),
        icon: 'theme-icon-sand-clock',
        data: {
            timeShiftDelay: 0
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            var data = [
                {name: gettext('By pressing \"Pause\" button'), value: 0},
                {name: '1 ' + gettext('sec'), value: 1000},
                {name: '3 ' + gettext('sec'), value: 3000},
                {name: '5 ' + gettext('sec'), value: 5000},
                {name: '10 ' + gettext('sec'), value: 10000}

            ];

            data.forEach(function ( item ) {
                item.selected = item.value === currentValue.timeShiftDelay;
            });

            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.data.timeShiftDelay = value;

            ts.delay = value;
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'timeshift'
    };
};
